import React from 'react';
import { arrayOf, object } from 'prop-types';
import styled from 'styled-components';

import Divider from './Divider';
import ReasonList from './ReasonList';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 0px;
  background-color: #fff;
`;

const Text = styled.h2`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 24px;
  line-height: 1.33;
  text-align: center;
  margin-bottom: 32px;
  color: #4a4a4a;
`;

const ReasonBox = ({ reasons }) => (
  <Container>
    <Divider />
    <Text>Por que anunciar na OLX?</Text>
    <ReasonList reasons={reasons} />
  </Container>
);

ReasonBox.propTypes = {
  reasons: arrayOf(object),
};

ReasonBox.defaultProps = {
  reasons: [],
};

export default ReasonBox;
